import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles({
  stepperRoundButton: {
    borderRadius: "50%",
    fontSize: 20,
    minWidth: 28,
    maxWidth: 28,
    minHeight: 28,
    maxHeight: 28,
    padding: 0,
    color: "black",
    borderColor: "#dadce0",
  },
  sideMargin: {
    marginLeft: 10,
    marginRight: 10,
  },
});

export default useStyles;
